import { makeStyles } from '@material-ui/core'
import Box from '@material-ui/core/Box'
import Hidden from '@material-ui/core/Hidden'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import LeftArrowIcon from '@material-ui/icons/ArrowLeft'
import RightArrowIcon from '@material-ui/icons/ArrowRight'
import { StoryblokComponent } from '@sb-konzept/gatsby-source-storyblok'
import { usePageContext } from 'components/PageContext'
import { graphql, useStaticQuery } from 'gatsby'
// import { splitEvery } from 'ramda'
import React, { useEffect, useMemo, useState } from 'react'

const useStyles = makeStyles((theme) => ({
  marginTop: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'stretch',

    [theme.breakpoints.down('md')]: {
      marginTop: 84
    }
  },
  mediaMargin: {
    margin: '-12px -12px -12px 0',
    [theme.breakpoints.down('md')]: {
      margin: 0
    }
  },
  mediaPadding: {
    padding: 12,
    flex: '1 1 34%',

    [theme.breakpoints.down('md')]: {
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 12,
      paddingBottom: 12,
      flex: '1 1 51%'
    }

    // [theme.breakpoints.down('md')]: {
    //   flex: '1 1 51%'
    // }
  },
  iconButton: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: 0,

    '&:hover': {
      backgroundColor: theme.palette.primary.main
    }
  }
}))

// Split the array into chunks
function split(arr, n) {
  const res = []
  if (n < 1 || n > arr.length) return [arr]
  const clone = [...arr]
  while (clone.length) {
    res.push(clone.splice(0, n))
  }
  return res
}

// // Run the correct filter on the item and return the mutated array
// function determineFilter(acc, e, displayOld) {
//   const {
//     node: {
//       content: { date }
//     }
//   } = e
//   if (!date) return null
//   if (displayOld) return new Date(date) < new Date() ? [...acc, e] : acc
//   return new Date(date) > new Date() ? [...acc, e] : acc
// }

// // This reducer filters the news but always leaves at least one item
// function reducer(array, displayOld) {
//   const result = array.reduce((acc, e, idx, arr) => {
//     if (idx >= arr.length - 1 && acc.length < 1) return [...acc, e]
//     return determineFilter(acc, e, displayOld)
//   }, [])
//   return result
// }

const regex = new RegExp('^((?!standort).)*$')

const StoryblokNewsBlock = (props) => {
  const staticQuery = useStaticQuery(graphql`
    {
      allStoryblokNewsEntryStory {
        edges {
          node {
            ...storyblokNewsEntryStory
          }
        }
      }
    }
  `)

  const context = usePageContext()
  const { page: pageContext } = context
  const { full_slug } = pageContext
  const { allStoryblokNewsEntryStory } = staticQuery
  const { edges } = allStoryblokNewsEntryStory
  const { content } = props
  const { sortAscending, cardsPerPage, stackDirection } = content

  const [page, setPage] = useState(0)
  const [pageNews, setPageNews] = useState([])
  const [filteredPageNews, setFilteredPageNews] = useState([])

  const slugs = full_slug?.match(/standort(\/.*\/)/)
  const slug = slugs ? slugs[1].replace(/\//g, '') : props.siteInfo?.location // standort name only
  const classes = useStyles()

  // Save the local news to state, and the general if !localNews || page is not standort
  useEffect(() => {
    let allNews = edges.filter((e) => {
      const query = `/${slug}/` || regex // Regex untested!
      return e.node.full_slug.match(query)
    })
    // If the local page news is an empty array, use the general page news
    if (!allNews.length) {
      allNews = edges.filter((e) => e.node.full_slug.match(regex))
    }
    setPageNews(allNews)
  }, [edges, slug])

  // Update DOM and filteredNews when options are changed
  useEffect(() => {
    if (!pageNews.length) return
    const tempNews = [...pageNews].sort((a, b) =>
      sortAscending
        ? new Date(b.node.content.date) - new Date(a.node.content.date)
        : new Date(a.node.content.date) - new Date(b.node.content.date)
    )
    // if (displayOld) {
    //   tempNews = reducer(tempNews, displayOld)
    // }
    setFilteredPageNews(tempNews)
  }, [setFilteredPageNews, pageNews, sortAscending])

  const pages = useMemo(() => split(filteredPageNews, cardsPerPage), [
    filteredPageNews,
    cardsPerPage
  ])

  return (
    <Box className={classes.marginTop} flex={1} position="relative">
      {/* Page buttons */}
      <Box
        display="flex"
        justifyContent="flex-end"
        left={0}
        position="absolute"
        // right={{ xs: 12, lg: 0 }}
        right={0}
        top="-48px"
      >
        <Hidden lgUp>
          <Box flex="1">
            <Typography variant="h3">BERICHTE</Typography>
          </Box>
        </Hidden>

        <Box mr={1}>
          <IconButton
            aria-label="left_arrow"
            className={classes.iconButton}
            color="inherit"
            disabled={page <= 0}
            size="small"
            onClick={() => page > 0 && setPage(page - 1)}
          >
            <LeftArrowIcon color="inherit" />
          </IconButton>
        </Box>
        <Box>
          <IconButton
            aria-label="right_arrow"
            className={classes.iconButton}
            color="inherit"
            disabled={page >= pages.length - 1}
            size="small"
            onClick={() => page < pages.length - 1 && setPage(page + 1)}
          >
            <RightArrowIcon color="inherit" />
          </IconButton>
        </Box>
      </Box>

      {/* Container */}
      <Box
        className={classes.mediaMargin}
        display="flex"
        flex={1}
        flexDirection={stackDirection || 'row'}
        flexWrap="wrap"
        justifyContent="space-between"
      >
        {/* Pages */}
        {pages[page]?.map((edge, idx) => (
          <Box
            key={edge.node.id || edge.node.uuid}
            // flex={stackDirection === "row" ? "1 1 45%" : "1 1 100%"}
            className={classes.mediaPadding}
          >
            <StoryblokComponent content={edge.node.content} />
          </Box>
        ))}
      </Box>
    </Box>
    // )
    //   }
    // }
    // />
  )
}

export default StoryblokNewsBlock
